"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mappers_1 = require("../products/mappers");
var utils_1 = require("../utils");
exports.productOptionsAvailabilityMapper = function (item) {
    return __assign(__assign({ availableForPurchase: item.availableForPurchase || false, productOptions: (item.productOptions || []).reduce(function (options, option) {
            var _a;
            return (__assign(__assign({}, options), (_a = {}, _a[option.name] = __assign(__assign({}, option), { choices: option.choices.map(function (choice) { return (__assign(__assign({}, utils_1.omitMedia(choice)), mappers_1.mediaMapper(choice.media))); }) }), _a)));
        }, {}) }, mappers_1.mediaMapper(item.media)), { selectedVariant: (item.selectedVariant && {
            sku: item.selectedVariant.sku,
            currency: item.selectedVariant.price.currency,
            price: item.selectedVariant.price.price,
            discountedPrice: item.selectedVariant.price.discountedPrice,
            formattedPrice: item.selectedVariant.price.formatted.price,
            formattedDiscountedPrice: item.selectedVariant.price.formatted.discountedPrice,
            visible: item.selectedVariant.visible,
            inStock: item.selectedVariant.inStock,
            weight: item.selectedVariant.weight,
        }) ||
            null });
};
//# sourceMappingURL=productOptionsAvailability.mapper.js.map